module.exports = __webpack_public_path__ + "static/media/home-white-logo.1855ac5a.svg";